<template>
  <div class="card-profile-sales-graph-header">
    <align>
      <div>
        <helper-text :help-text="helpText">
          <h4 class="short-text secondary-font">{{ titleText }}</h4>
        </helper-text>

        <div class="small-text" v-if="auctionOnly && cardId">Auctions only</div>
      </div>
    </align>

    <align small-gap>
      <pro-label
        v-if="isPublic"
        tooltip="Go Pro today to see all individual sales!"
        as="nuxt-link"
        to="/pricing"
      />

      <icon-link v-if="showViewAllSales" @click="goToSales">
        View All Sales
      </icon-link>
    </align>
  </div>
</template>

<script>
import Align from './Align';
import HelperText from './HelperText';
import ProLabel from './ProLabel';
import IconLink from './IconLink';

export default {
  components: {
    Align,
    HelperText,
    ProLabel,
    IconLink,
  },

  props: {
    auctionOnly: Boolean,
    isPublic: Boolean,
    cardId: String,
    card: Object,
  },

  computed: {
    showViewAllSales() {
      return !this.$route.query.showSales && (this.card?.ebayQuery || this.hasGradedCardSalesMatch);
    },

    hasGradedCardSalesMatch() {
      return this.card && this.card.useGradedCardAutomatic && this.card.profileId && this.card.grade && this.card.grader;
    },

    parentRoute() {
      let parentRoute = this.$route.query.type || 'ladder';

      return parentRoute;
    },

    showSales() {
      return this.cardId || (this.card?.ebayQuery && this.card?.useSalesForValue) || this.hasGradedCardSalesMatch;
    },

    titleText() {
      return this.showSales ? 'Sales' : 'Estimated Values';
    },

    helpText() {
      return this.showSales
        ? `This graph displays all sales in this card's history normalized by the day.${this.showViewAllSales ? ' If you want to see each individual sale just choose View All Sales from the options menu.' : ''}${this.auctionOnly ? ' Due to high transaction volume only auctions are tracked for this card.' : ''}${this.isPublic ? ' Sales are limited to the last 3 months. Our PRO version offers all-time sales history.' : ''}`
        : 'This graph displays all estimated values taking into account the multipliers you have setup, your estimated value and your purchase price/date. This does not reflect actual sales comps but merely gives you an estimate value over the time you owned the card. This graph will update once per day.';
    },
  },

  methods: {
    goToSales() {
      if (this.isPublic) {
        this.$router.push('/pricing');
      } else if (this.$route.name === 'Card') {
        this.$router.push({
          query: {
            ...this.$route.query,
            showSales: true,
          },
        });
      } else {
        const query = {
          ...this.$route.query,
          showSales: true,
          backTo: this.$route.name,
        };

        delete query.cardId;

        if (this.$route.name === 'Player' || this.$route.name === 'Index') {
          query.backToName = this.$route.params.name;
        }

        this.$router.push({
          path: `/card/${this.$route.query.cardId}`,
          query,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-profile-sales-graph-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: $gp;
}

h4 {
  margin-bottom: 0;
}

.small-text {
  font-size: 12px;
}

.pro-label {
  margin-right: $gp * .25;
}
</style>
